import { copyRegistry } from '~/copy/registry';
import { resolveCopy } from '~/copy/resolve';
import { useCopyContext } from './copy-context';

export function Copy({ id }: { id: string }) {
  const { overrides, editMode, locale } = useCopyContext();
  const entry = copyRegistry[id];

  if (!entry) {
    if (typeof console !== 'undefined') console.warn(`[Copy] unknown copy key: ${id}`);
    return null;
  }

  const text = resolveCopy(overrides, id, entry.default, locale);

  if (editMode) {
    return (
      <span data-copy-key={id} data-copy-page={entry.page} data-copy-section={entry.section}>
        {text}
      </span>
    );
  }
  return <>{text}</>;
}
